import { changeTariffFromBackend } from '@entities/tariff/lib';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const createEstimateUser = async (formData: FormData) => {
    // @ts-ignore
    const url = routable.getRoute('createEstimateUser');

    try {
        return await $api.post(url, formData);
    } catch (error) {
        if (error?.response?.data.status === 'tariff-error') {
            await changeTariffFromBackend(error?.response?.data.tariff_popup_url);
        } else {
            handleAxiosFetchErrorsSwal(error?.response?.data);
        }
        return error;
    }
};
